import React from "react";

export const LazyDealPage = React.lazy(
  () => import("modules/investorRole/pages/DealsPage/DealPage"),
);
